"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ChildFields = _styledComponents.default.div.withConfig({
  displayName: "ChildFields",
  componentId: "design-system__sc-1em8tpg-0"
})(["padding-left:1.5rem;padding-top:1.5rem;margin-left:1rem;position:relative;:before,:after{content:'';display:block;position:absolute;left:0;}:before{width:0;height:calc(100% - 20px);top:0;border-left:2px dashed ", ";}:after{width:1.5rem;height:0;bottom:20px;border-bottom:2px dashed ", ";}> div{align-items:flex-end;& .Field{flex-grow:1;}& + div{margin-top:2rem;}}"], _BaseTheme.default.colors.bluegray, _BaseTheme.default.colors.bluegray);

const Line = _styledComponents.default.div.withConfig({
  displayName: "ChildFields__Line",
  componentId: "design-system__sc-1em8tpg-1"
})(["position:relative;:before{content:'';display:block;position:absolute;left:-1.5rem;width:1.5rem;height:0;bottom:20px;border-bottom:2px dashed ", ";}"], _BaseTheme.default.colors.bluegray);

ChildFields.Line = Line;
var _default = ChildFields;
exports.default = _default;